import * as React from 'react';
import * as styles from './attribute-row.module.scss';
import { useSegmentResults } from '../../../hooks/useSegmentResults';
import { useBuildSegment, useBuildSegmentComposition } from './useBuildSegment';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { SegmentAttributeGroup } from '../../../models/segments';

interface Props {
  /** Indicate the position in the results array to find the relevant customer results */
  order: number;
  exclude?: boolean;
}

const defaultGroup: SegmentAttributeGroup = {
  operator: 0,
  predicates: []
};

const AttributeRowCustomers = ({ order, exclude }: Props) => {
  const { selectedAttributes: includedAttributes } = useBuildSegment();
  const { selectedAttributes: excludedAttributes } = useBuildSegment(true);
  const { selectedComoposition: includedComposition } = useBuildSegmentComposition();
  const { selectedComoposition: excludedComposition } = useBuildSegmentComposition(true);

  const resultsQuery = useSegmentResults(
    includedAttributes,
    excludedAttributes,
    includedComposition,
    excludedComposition
  );

  const perIncludedAttributeGroup = resultsQuery.data?.perAttributeGroup.include;
  const includedAttributeCustomers = perIncludedAttributeGroup ? perIncludedAttributeGroup[order] : undefined;

  const perExcludedAttributeGroup = resultsQuery.data?.perAttributeGroup.exclude;
  const excludedAttributeCustomers = perExcludedAttributeGroup ? perExcludedAttributeGroup[order] : undefined;

  const attributeCustomers = exclude ? excludedAttributeCustomers : includedAttributeCustomers;

  return (
    <div className={styles.customerCountRow}>
      <div className={styles.customerCountBox}>
        {resultsQuery.isLoading && (
          <div className={styles.customerCount}>
            <CircularProgress size={'1em'} />
          </div>
        )}
        {resultsQuery.data && (
          <p
            className={clsx(
              styles.customerCount,
              resultsQuery.isPreviousData && resultsQuery.isFetching && styles.customersFetching
            )}
          >
            {`${attributeCustomers?.toLocaleString() || 0} ${
              attributeCustomers !== 1 ? 'customers meet criteria' : 'customer meets criteria'
            }`}
          </p>
        )}
      </div>
    </div>
  );
};

export default AttributeRowCustomers;
